/**
 * Obsługa skip linków zgodnie z dyrektywą WCAG
 */
app.service('wcagSkipLinks',function(){
	let $self, $links;

	function focusFirstElement($parent) {
		// focus tylko na interaktywnych elementach, które nie są display:none
		$parent.find('button:visible, a:visible, input:visible, select:visible, textarea:visible, [tabindex]:visible:not([tabindex="-1"])').eq(0).focus();
	}
	function scrollAnimate($target, offset = 0, speed = 500) {
		$('html, body').animate({
			scrollTop: $target.offset().top + offset
		}, speed);
	}
	function selectTargetAction(skipTarget) {
		switch (skipTarget) {
			case 'main-content':
				skipToContent();
				break;
			case 'main-search':
				skipToSearchBox();
				break;
			case 'main-menu':
				skipToMainMenu();
				break;
			case 'main-footer':
				skipToMainFooter();
				break;
			default:
				console.warn('Brak elementu docelowego:', skipTarget);
		}
	}

	function skipToContent() {
		const $mainContent = $('#headless-main-menu + div'); // bo może być #container, .page, i pewnie też kilka innych
		if ($mainContent.length) {
			focusFirstElement($mainContent);
		}
	}
	function skipToMainMenu() {
		const $navToggleSticky = $('.sticky #nav-toggle-sticky');
		const $navToggle = $('#nav-toggle');
		if ($navToggleSticky.length) {
			$navToggleSticky.focus();
		} else {
			$navToggle.focus();
		}
	}
	function skipToSearchBox() {
		const $searchBox = $('#search-box');
		if ($searchBox.length) {
			console.log('Skip to search box', $searchBox, $('#keyword'));
			setTimeout(() => {
				$('#keyword', $searchBox).trigger('focus');
			}, 100); // opóźnienie, żeby poprawnie ustawić focusa, bez przekazanego 'entera'
		}
	}
	function skipToMainFooter() {
		const $footer = $('#main-footer');
		if ($footer.length) {
			scrollAnimate($footer, -160); // 160px offset dla sticky headera
			focusFirstElement($footer);
		}
	}

	function init() {
		$self = $('#header-skip-links');
		$links = $('.skip-link', $self);

		if ($links.length > 0) {
			$links.on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				selectTargetAction($(this).attr('data-skip-target'));
			});
		}
	}
	return {
		init,
	};
});
